module.exports = __webpack_public_path__ + "static/img/bg-yuezhenxiaochu.82b4b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-yuezhenxiaochu.png
// module id = TTsv
// module chunks = 0